import cookie from "@utils/Cookie";
import { MEMBER_TOKEN } from "@constant/StorageKeyValue";

/**
 * 取得登入用戶資料
 * @returns {{ userId: number | undefined, userName: string | undefined }}
 */
const useMemberInfo = (): { userId: number | undefined; userName: string | undefined } => {
  const tokenInfo = cookie.getItem(MEMBER_TOKEN);
  return {
    userId: tokenInfo?.userId,
    userName: tokenInfo?.userName,
  };
};

export default useMemberInfo;
